export interface FrontendConfig {
    appBasePath: string;
}
export const frontendConfig: FrontendConfig = {
    appBasePath: ''
};
